export enum CrmTypesEnum {
    HUBSPOT = 'HUBSPOT',
    ZOHO = 'Zoho',
    SALESFORCE = 'SALESFORCE'
}
